module.exports = __webpack_public_path__ + "img/free-press-journal.ec3670e6.png";